import { Box, Slider, Typography } from '@mui/material';
import { CONTRAST_MIN, CONTRAST_MAX } from '../constants';

export interface ContrastControlsProps {
  contrast: number;
  onContrastChange: (contrast: number) => void;
}

export const ContrastControls = ({
  contrast,
  onContrastChange,
}: ContrastControlsProps) => {
  return (
    <Box>
      <Typography
        color="white"
        sx={{ display: { xs: 'none', md: 'block' }, mt: 1 }}
      >
        Contrast
      </Typography>
      <Slider
        value={contrast}
        onChange={(_, val) => onContrastChange(val as number)}
        min={CONTRAST_MIN}
        max={CONTRAST_MAX}
        sx={{ color: 'white', width: 200 }}
      />
    </Box>
  );
};
